export const COMMUNITY_ENTITY_TYPE = 'Community';
export const PROPERTY_ENTITY_TYPE = 'Property';
export const AGENT_ENTITY_TYPE = 'PartnerAgent';
export const REAL_ESTATE_AGENT_ENTITY_TYPE = 'RealEstateAgent';
export const CLIENT_ENTITY_TYPE = 'Client';
export const SLY_ENTITY_RESOURCE_TYPE = 'SlyEntity';

export const ENTITY_LABEL_MAP = {
  [PROPERTY_ENTITY_TYPE]: 'Property',
  [COMMUNITY_ENTITY_TYPE]: 'Community',
  [AGENT_ENTITY_TYPE]: 'Agent',
  [REAL_ESTATE_AGENT_ENTITY_TYPE]: 'Real Estate Agent'
};

export const LISTING_ENTITY_TYPE = 'Listing';
